import { PageHeader, Section } from "@/components/site/PageChrome";
import { Link } from "react-router-dom";
import {
  Download,
  Store,
  Sparkles,
  Users,
  Phone,
  HelpCircle,
  Shield,
  FileText,
  Briefcase,
  Newspaper,
  Star,
  Mail,
  ArrowUpRight,
  MessageCircle,
  Instagram,
  Youtube,
  Linkedin,
  Twitter,
  Send,
  MapPin,
  Globe,
} from "lucide-react";
import { waLink } from "@/components/site/FloatingWhatsApp";

const links = [
  {
    to: "https://play.google.com/store/apps/details?id=YOUR_PACKAGE_NAME",
    icon: Download,
    t: "Download App",
    d: "Install the official Time2Cash app",
    accent: true,
    external: true,
  },
  {
    to: waLink("Hi Time2Cash! I need some support."),
    icon: MessageCircle,
    t: "WhatsApp Support",
    d: "Chat with our support team",
    external: true,
  },
  {
  to: "/pre-registrations",
  icon: Store,
  t: "Shop Pre-Registration",
  d: "Reserve your business before launch & unlock exclusive founding partner benefits",
},
  {
    to: "/shops/register",
    icon: Store,
    t: "Register Your Business",
    d: "Create your business profile",
  },
  {
    to: "/ambassador",
    icon: Users,
    t: "Become an Ambassador",
    d: "Represent Time2Cash in your city",
  },
  {
    to: "/features",
    icon: Sparkles,
    t: "Features",
    d: "Explore everything Time2Cash offers",
  },
  {
    to: "/contact",
    icon: Phone,
    t: "Contact Us",
    d: "Support & business enquiries",
  },
  {
    to: "/faq",
    icon: HelpCircle,
    t: "Help & FAQ",
    d: "Frequently asked questions",
  },
  {
    to: "/blog",
    icon: Newspaper,
    t: "Blog & Updates",
    d: "Latest announcements",
  },
  {
    to: "/careers",
    icon: Briefcase,
    t: "Careers",
    d: "Join our team",
  },
  {
    to: "/privacy",
    icon: Shield,
    t: "Privacy Policy",
    d: "Your privacy matters",
  },
  {
    to: "/terms",
    icon: FileText,
    t: "Terms & Conditions",
    d: "Platform policies",
  },
  {
    to: "mailto:hello@time2cash.co",
    icon: Mail,
    t: "Email Support",
    d: "hello@time2cash.co",
    external: true,
  },
  {
    to: "https://instagram.com/time2cash.co",
    icon: Instagram,
    t: "Instagram",
    d: "Follow our latest updates",
    external: true,
  },
  {
    to: "https://youtube.com/@Time2Cash-Co",
    icon: Youtube,
    t: "YouTube",
    d: "Watch videos & tutorials",
    external: true,
  },
  {
    to: "https://www.linkedin.com/in/time2cash-co/",
    icon: Linkedin,
    t: "LinkedIn",
    d: "Connect with us",
    external: true,
  },
  {
    to: "https://x.com/time2cash_co",
    icon: Twitter,
    t: "X (Twitter)",
    d: "Latest announcements",
    external: true,
  },
  {
    to: "https://maps.google.com/?q=Anantapur",
    icon: MapPin,
    t: "Office Location",
    d: "View on Google Maps",
    external: true,
  },
  {
    to: "https://time2cash.co",
    icon: Globe,
    t: "Official Website",
    d: "Visit time2cash.co",
    external: true,
  },
];

export default function QuickLinksPage() {
  return (
    <>
      <PageHeader
        eyebrow="Quick Links"
        title="Everything, one tap away."
        subtitle="A hub to every important page on the Time2Cash website — jump straight to what you need."
      />
      <Section>
        <div data-testid="quick-links-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {links.map(({ to, icon: Icon, t, d, accent, external }) => {
            const inner = (
              <>
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${accent ? "bg-white/20" : "bg-[#FFF3ED]"}`}>
                  <Icon className={`w-6 h-6 ${accent ? "text-white" : "text-[#FF5A00]"}`} />
                </div>
                <div className="mt-4 flex items-start justify-between">
                  <div>
                    <h3 className={`text-lg font-bold ${accent ? "text-white" : "text-[#1A1918]"}`}>{t}</h3>
                    <p className={`mt-1 text-sm ${accent ? "text-white/80" : "text-[#4A4846]"}`}>{d}</p>
                  </div>
                  <ArrowUpRight className={`w-5 h-5 ${accent ? "text-white/80" : "text-[#78716C]"}`} />
                </div>
              </>
            );
            const cls = `group rounded-3xl border p-6 transition-all hover:-translate-y-1 ${accent ? "bg-[#FF5A00] border-[#FF5A00] shadow-lg shadow-orange-500/25" : "bg-white border-[#EBE8E3] hover:shadow-lg"}`;
            return external ? (
              <a key={t} href={to} className={cls}>{inner}</a>
            ) : (
              <Link key={t} to={to} className={cls}>{inner}</Link>
            );
          })}
        </div>
      </Section>
    </>
  );
}
